// src/offline/offlineDb.js
// Tiny persistence for offline sync metadata (last-synced time, counters).
// Kept dependency-free; values are small so localStorage is sufficient.

const META_KEY = 'offlineSyncMeta';

const read = () => {
  try {
    const raw = localStorage.getItem(META_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

const write = (meta) => {
  try {
    localStorage.setItem(META_KEY, JSON.stringify(meta));
  } catch (e) {
    /* storage full/blocked — non-fatal */
  }
};

export const getSyncMeta = () => read();

export const setLastSyncedAt = (timestamp) => {
  const meta = read();
  meta.lastSyncedAt = timestamp;
  write(meta);
};

export const getLastSyncedAt = () => read().lastSyncedAt || null;

export const setSyncStats = (stats) => {
  const meta = read();
  meta.stats = stats;
  write(meta);
};
